module.exports = require("node-fetch");


//////////////////
// WEBPACK FOOTER
// external "node-fetch"
// module id = 26
// module chunks = 0